import { HeroImage } from "modules/sections/HeroImage";
import type { HeroImageProps } from "modules/sections/HeroImage";
import type { ReactStoryblokComponent } from "types/storyblok";

const HeroImageSectionAdapter = ({
  blok: { srcMobile, alt, srcDesktop, heading, subHeading },
  sbEditable,
}: ReactStoryblokComponent<HeroImageProps>) => (
  <HeroImage
    srcDesktop={srcDesktop}
    alt={alt}
    srcMobile={srcMobile}
    heading={heading}
    subHeading={subHeading}
    sbEditable={sbEditable}
  />
);
export default HeroImageSectionAdapter;
